var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrimarySmall = function SvgPrimarySmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 200 200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0A3A6B",
    d: "m103.784 1.876 28.4 37.35a150 150 0 0 0 28.59 28.59l37.35 28.4c2.501 1.9 2.501 5.667 0 7.568l-37.35 28.4a150 150 0 0 0-28.59 28.59l-28.4 37.35c-1.901 2.501-5.668 2.501-7.568 0l-28.4-37.35a150 150 0 0 0-28.59-28.59l-37.35-28.4c-2.501-1.901-2.501-5.668 0-7.568l37.35-28.4a150 150 0 0 0 28.59-28.59l28.4-37.35c1.9-2.501 5.667-2.501 7.568 0"
  })));
};
export default SvgPrimarySmall;